var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg06Grumpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 59.9999C46.5685 59.9999 59.9999 46.5685 59.9999 29.9999C59.9999 13.4314 46.5685 0 29.9999 0C13.4314 0 0 13.4314 0 29.9999C0 46.5685 13.4314 59.9999 29.9999 59.9999Z",
    fill: "#6FCC87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.4286 55.5707C19.8601 55.5707 6.42875 42.1393 6.42875 25.5709C6.42875 16.7189 10.2633 8.76372 16.3612 3.27246C6.64894 8.23837 0 18.3425 0 29.9996C0 46.5681 13.4314 59.9994 29.9998 59.9994C37.7165 59.9994 44.7517 57.085 50.0672 52.2982C45.9753 54.3903 41.34 55.5707 36.4286 55.5707Z",
    fill: "#186C2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8063 20.7139C44.8063 22.9647 46.6309 24.7892 48.8815 24.7892C51.1324 24.7892 52.9568 22.9646 52.9568 20.7139H39.1641",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9606 20.7139C23.9606 22.9647 25.7852 24.7892 28.0358 24.7892C30.2865 24.7892 32.1111 22.9646 32.1111 20.7139H18.3184",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1777 46.355C26.8509 46.355 26.5248 46.2245 26.2845 45.9664C25.8251 45.4732 25.8524 44.7011 26.3455 44.2416C28.3957 42.3315 31.9667 41.145 35.6651 41.145C39.5323 41.145 43.0071 42.3143 44.9603 44.2727C45.4363 44.75 45.4351 45.5227 44.9581 45.9985C44.4808 46.4746 43.708 46.4734 43.232 45.9963C41.7493 44.5095 38.8497 43.5859 35.6651 43.5859C32.5596 43.5859 29.6259 44.5215 28.0094 46.0276C27.7741 46.2466 27.4754 46.355 27.1777 46.355Z",
    fill: "#186C2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9565 19.4932H39.1637C38.4897 19.4932 37.9434 20.0396 37.9434 20.7135C37.9434 21.3875 38.4898 21.9339 39.1637 21.9339H43.7273C44.28 24.2676 46.381 26.0092 48.8812 26.0092C51.8013 26.0092 54.1769 23.6335 54.1769 20.7135C54.177 20.0394 53.6306 19.4932 52.9565 19.4932ZM48.8812 23.5685C47.7435 23.5685 46.759 22.8993 46.3005 21.934H51.4618C51.0035 22.8993 50.019 23.5685 48.8812 23.5685Z",
    fill: "#186C2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3312 20.7135C33.3312 20.0395 32.7848 19.4932 32.1108 19.4932H18.318C17.644 19.4932 17.0977 20.0396 17.0977 20.7135C17.0977 21.3875 17.6441 21.9339 18.318 21.9339H22.8816C23.4343 24.2676 25.5353 26.0092 28.0355 26.0092C30.9556 26.0093 33.3312 23.6335 33.3312 20.7135ZM25.4548 21.934H30.6161C30.1577 22.8996 29.1732 23.5685 28.0354 23.5685C26.8978 23.5685 25.9133 22.8993 25.4548 21.934Z",
    fill: "#186C2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06Grumpy);
export default __webpack_public_path__ + "static/media/06-Grumpy.c487331da66f3ce9e81598a4bb97514e.svg";
export { ForwardRef as ReactComponent };